import { Alert } from "@justworkshr/milo-core";

export const ErrorAlert = ({ error }: { error: string | null }) => (
  <Alert color="destructive">{error}</Alert>
);
